module.exports = __webpack_public_path__ + "img/ic_emoji.7a1ff587.svg";